import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconFunnel = {
    alias: 'funnel',
    defaultTitle: 'Funnel',
    source: ({ Path }, { variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M13.903 22a.992.992 0 0 1-.603-.203l-4.026-3.045a1 1 0 0 1-.397-.797v-3.274L4.111 5.459A.999.999 0 0 1 5.001 4h14a1 1 0 0 1 .88 1.475l-4.978 9.215V21a1.003 1.003 0 0 1-1 1' }))) : (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm10.879 17.457 2.026 1.533v-4.553c0-.166.042-.329.12-.475L17.325 6H6.645l4.122 7.978c.074.142.112.3.112.459v3.02ZM13.902 22a.994.994 0 0 1-.603-.203l-4.026-3.045a1 1 0 0 1-.397-.797v-3.274L4.112 5.459A1 1 0 0 1 5 4h14a1 1 0 0 1 .88 1.475l-4.977 9.215V21a1 1 0 0 1-1 1Z' }))),
};
